import { IDs, SCREEN_TYPE, PLAYER_MODE, WINDOW_MODE } from "../constants";
import { PLAYER_CONTROLS } from "../theme/dimensions";
import { IS_ELECTRON_APP } from "../config";

let remote = "";
if (IS_ELECTRON_APP) remote = window.require("electron").remote;

const MIN_WIDTH = 720;

class UIManager {
  constructor() {
    this.lastW = window.innerWidth;
    this.lastH = window.innerHeight;
    const w = window.innerWidth,
      h = window.innerHeight;
    this.state = {
      playerMode: PLAYER_MODE.COLLAPSED,
      screen: w <= MIN_WIDTH ? SCREEN_TYPE.MOBILE : SCREEN_TYPE.SUPPORTED,
      playerTheme: "dynamic",
      windowMode: WINDOW_MODE.UN_MAX,
    };
    this.uiStateSetter = null;

    this.addListeners();
  }
  addListeners = () => {
    window.addEventListener("resize", this.onResize);
    document.addEventListener("fullscreenchange", this.onFullScreenChange);
    document.addEventListener("mozfullscreenchange", this.onFullScreenChange);
    document.addEventListener(
      "webkitfullscreenchange",
      this.onFullScreenChange
    );
    document.addEventListener("msfullscreenchange", this.onFullScreenChange);
  };
  getState = () => {
    return this.state;
  };

  onSetState = () => {
    if (this.uiStateSetter) this.uiStateSetter(this.state);
  };
  debounce = (func, delay) => {
    let debounceTimer;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
  };
  newStateCaller = this.debounce(this.onSetState, 100);
  setState = (newState) => {
    // merge changes with current state
    this.state = { ...this.state, ...newState };
    this.newStateCaller();
  };

  register = (stateManager) => {
    this.uiStateSetter = stateManager;
    this.onResize();
  };

  onResize = () => {
    if (
      document.fullscreenElement ||
      (this.state.playerMode === PLAYER_MODE.MINI && IS_ELECTRON_APP)
    ) {
      this.setState({ screen: SCREEN_TYPE.SUPPORTED });
      return;
    }
    const w = window.innerWidth,
      h = window.innerHeight;
    this.setState({
      screen: w <= MIN_WIDTH ? SCREEN_TYPE.MOBILE : SCREEN_TYPE.SUPPORTED,
    });
  };

  onFullScreenChange = () => {
    if (document.fullscreenElement)
      this.setState({ playerMode: PLAYER_MODE.FULL });
    else this.expandPlayer();
  };

  expandPlayer = () => {
    const playerSheet = document.getElementById(IDs.PLAYER_SHEET);
    if (playerSheet) {
      playerSheet.style.height = `calc( ${
        IS_ELECTRON_APP ? "95vh" : "100vh"
      } - ${PLAYER_CONTROLS.HEIGHT}px)`;
      this.setState({ playerMode: PLAYER_MODE.EXPANDED });
    }
  };

  collapsePlayer = () => {
    const mode = this.state.playerMode;
    const playerSheet = document.getElementById(IDs.PLAYER_SHEET);
    if (playerSheet) {
      playerSheet.style.height = `0px`;
      if (mode !== PLAYER_MODE.MINI)
        this.setState({ playerMode: PLAYER_MODE.COLLAPSED });
    }
  };

  enterFullScreenMode = () => {
    if (document.fullscreenElement) return;
    const player = document.getElementById(IDs.VIDEO_PLAYER);
    if (player.requestFullscreen) {
      player.requestFullscreen();
    } else if (player.mozRequestFullScreen) {
      player.mozRequestFullScreen();
    } else if (player.webkitRequestFullscreen) {
      player.webkitRequestFullscreen();
    } else if (player.msRequestFullscreen) {
      player.msRequestFullscreen();
    }
  };

  exitFullScreenMode = () => {
    if (!document.fullscreenElement) return;
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  };

  enterMiniMode = () => {
    //resize screen
    if (IS_ELECTRON_APP) {
      const win = remote.getCurrentWindow();
      const w = 16 * 20,
        h = 9 * 20;
      win.setSize(w, h);
      win.setAlwaysOnTop(true);
      win.setPosition(
        Math.floor(window.screen.availWidth - w - 40),
        Math.floor(window.screen.availHeight - h - 40)
      );
    }
    this.setState({ playerMode: PLAYER_MODE.MINI });
    this.collapsePlayer();
  };

  exitMiniMode = () => {
    // resize back
    if (IS_ELECTRON_APP) {
      const win = remote.getCurrentWindow();
      win.setPosition(
        Math.floor((10 * window.screen.availWidth) / 100),
        Math.floor((10 * window.screen.availHeight) / 100)
      );
      win.setSize(
        Math.floor((80 * window.screen.availWidth) / 100),
        Math.floor((90 * window.screen.availHeight) / 100)
      );
      win.setAlwaysOnTop(false);
    }
    // this.setState({ playerMode: PLAYER_MODE.COLLAPSED });
    this.expandPlayer();
  };

  toggleMiniMode = () => {
    const mode = this.state.playerMode;
    this.exitFullScreenMode();
    if (mode === PLAYER_MODE.MINI) this.exitMiniMode();
    else this.enterMiniMode();
  };

  toggleFullScreen = () => {
    if (document.fullscreenElement) this.exitFullScreenMode();
    else this.enterFullScreenMode();
  };

  togglePlayer = () => {
    const mode = this.state.playerMode;
    // exit fullscreen->fullscreenchangelistner->expandplayer call
    this.exitFullScreenMode();
    if (mode === PLAYER_MODE.MINI) this.expandPlayer();
    else if (mode === PLAYER_MODE.COLLAPSED) this.expandPlayer();
    else this.collapsePlayer();
  };

  minimizeWindow = () => {
    const win = remote.getCurrentWindow();
    win.minimize();
  };

  maximizeWindow = () => {
    const win = remote.getCurrentWindow();
    win.maximize();
    this.setState({ windowMode: WINDOW_MODE.MAX });
  };

  unMaximizeWindow = () => {
    const win = remote.getCurrentWindow();
    win.unmaximize();
    this.setState({ windowMode: WINDOW_MODE.UN_MAX });
  };

  closeWindow = () => {
    const win = remote.getCurrentWindow();
    win.close();
  };
}

const instance = new UIManager();

export default instance;
